import React from "react";

export default class Dim extends React.Component {
    constructor(props) {
        super(props);
        this.state = { active: false };
        Dim.d = this;
        Dim.window = props.window;
    }
    
    static openDim() {
        const d = Dim.d;
        if(d.state.active) return; 
            
        document.body.style.overflowY = 'hidden';
        d.setState({ active: true });
    }

    static closeDim() {
        const d = Dim.d;
        if(!d.state.active) return; 
        
        document.body.style.overflowY = 'auto';
        Dim.window.closeWindow();
        d.setState({ active: false });
    }

    render() {
        return <div className={`dim-overlay ${this.state.active ? 'active' : ''}`} onClick={Dim.closeDim}></div>;
    }
}